<img
  #imageRef
  [src]="urlCMS"
  [class]="size"
  [ngClass]="{
    'animate__animated animate__zoomIn animate__slower': animated,
    'lg-brand': shape == 'square',
    'lg-brand-rd': shape == 'squarerd',
    'sm--BN': shape == 'square' && isBN
  }"
  *ngIf="hasCms"
  (error)="onErrorCMS($event)"
/>
<img
  #imageRef
  [src]="url"
  [class]="size"
  [ngClass]="{
    'animate__animated animate__zoomIn animate__slower': animated,
    'lg-brand': shape == 'square',
    'sm--BN': shape == 'square' && isBN
  }"
  *ngIf="hasLocal"
  (error)="onErrorLocal($event)"
/>
<img
  #imageRef
  [src]="urlDefault"
  [class]="size"
  [ngClass]="{
    'animate__animated animate__zoomIn animate__slower': animated,
    'lg-brand': shape == 'square',
    'sm--BN': shape == 'square' && isBN
  }"
  *ngIf="!hasCms && !hasLocal"
/>
